import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ImmigrationWizardService } from '../services/immigration-wizard.service';
import { Subject } from 'rxjs';
import { ImagilityBaseResponse } from 'app-models';
import { ConfirmationService } from 'primeng/api';
import { take, takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { GenericBeneficiaryPersonalDetailsLibraryComponent } from 'generic-beneficiary-personal-details-library';
@Component({
  selector: 'app-individual-details',
  templateUrl: './individual-details.component.html',
  styleUrls: ['./individual-details.component.scss']
})
export class IndividualDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  private destroy$ = new Subject<void>();
  primaryData: any;
  primaryDataCompletedBeneficiaryPersonalDetails: any;
  primaryDataCompletedBeneficiaryEducationDetails: any;
  isDataLoaded: boolean = false;
  docStatus: boolean = false;
  docsimpleStatus: boolean = false;
  inputData: any;
  wizardInput: any;
  // selectedProfile = 'simple';
  editDetails: boolean = false;

  primaryDataCompletedBeneficiaryExperienceDetails: any;
  formDetails: any;
  isRequestDataDocuments: boolean = false;
  benDataForReqDataDoc: any = {};
  documentType: any;
  requestDataResponseBen: any;
  showErrorBanner: boolean = true;
  showSuccessBanner: boolean = true;
  requestDataTitle: string = 'Request data and documents from individuals';
  individualDetailsTitle: string = 'Enter / Update Individual Details';

  selectedDetailAbout: any;
  showUploadPassport: boolean = true;
  personalDetailsEdit: boolean = false;
  beneficiaryProfileUpdate: any;
  profileEducationUpdate: boolean = true;
  profileUpdate: boolean = true;
  editClicked: boolean = true;
  chel:any;

  @ViewChild(GenericBeneficiaryPersonalDetailsLibraryComponent) GenericBeneficiaryPersonalDetailsLibraryComponent: GenericBeneficiaryPersonalDetailsLibraryComponent;

  constructor(
    private immigrationWizardService: ImmigrationWizardService,
    private confirmationService: ConfirmationService,
    private toastService: ToastrService,
    private el: ElementRef
  ) { }

  ngOnInit(): void {
    this.immigrationWizardService.getWizardTaskDetails$().subscribe((res: any) => {
      if (res && 'tempPetitionId' in sessionStorage) {
        this.primaryData = {
          superTaskId: res.superTaskId,
          subTaskId: res.id,
          caseType: res.subTaskTypeCode, //
          caseId: res.petitionId,
          petitionId: res.petitionId, //
          foreignCompanyId: null,
          visatype: res.taskTypeDetails.visaType, //
          visaName: res.taskTypeDetails.visaName,
          petitionType: res.taskTypeDetails.petitionType,
          immSpecialistId: res.immSpecialistId,
          attorneyId: res.attorneyId,
          sponsorId: res.sponsorId,
          familyId: res.familyId,
          immigrationCategory: null,
          immigrationCategoryName: null,
          immigrationClassification: null,
          immigrationClassificationName: null,
          superTaskTypeCode: res.superTaskTypeCode,
          getTaskType: res.taskTypeDetails.visaType,
          jsonInput: null,
          beneficiaryId: res.beneficiaryId,
          relationshipCode: null,
          taskTypeId: res.taskTypeId,
          taskTypeSaveJsonId: null,
          isWizrd: true,
          companyId: res?.companyId,
          visaType: res?.taskTypeDetails?.visaType
        };

        this.wizardInput = {
          title: this.isRequestDataDocuments ? this.requestDataTitle : this.individualDetailsTitle,
          data: {
            taskId: res?.superTaskId,
            individual: res?.beneficiaryDetails?.firstName + " " + res?.beneficiaryDetails?.lastName,
            petitionType: res?.taskTypeDetails?.petitionType,
            status: res?.taskStatus?.name
          }
        }

        this.primaryDataCompletedBeneficiaryPersonalDetails = this.setPrimaryDataStepWise('Enter Beneficiary Personal Details', res);
        this.primaryDataCompletedBeneficiaryEducationDetails = this.setPrimaryDataStepWise('Enter Beneficiary Education Details', res);
        this.primaryDataCompletedBeneficiaryExperienceDetails = this.setPrimaryDataStepWise('Enter Beneficiary Experience Details', res);

        this.isDataLoaded = true;
        this.benDataForReqDataDoc = {beneficiaryEmployeeId: res.beneficiaryId, beneficiaryEmployeeFName: res?.beneficiaryDetails?.firstName, beneficiaryEmployeeLName: res?.beneficiaryDetails?.lastName };
        this.getDataLog();
      }
    });
    localStorage.setItem("currentUserSelection", JSON.stringify(this.selectedDetailAbout));
    this.selectedDetailAbout = {
      showDetailFor: 'self',
    };
    this.personalDetailsEdit = (this.beneficiaryProfileUpdate == 'true');
    this.getBeneDetailsLibrary();
    this.immigrationWizardService.getWizardReqDataDocsDetails$().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if(res){
        this.isRequestDataDocuments = true;
        this.wizardInput = {...this.wizardInput, title: this.requestDataTitle};
      }
    });
  }

  ngAfterViewInit(): void {
    this.chel = this.GenericBeneficiaryPersonalDetailsLibraryComponent;
    console.log(this.chel)
  }

  onHasPassportChange(flag: boolean) {
    this.showUploadPassport = flag;
  }

  personalDetails(param) {
    this.getBeneDetailsLibrary();
}


onEditClicked(status) {
  this.editClicked = status;
}


getBeneDetailsLibrary() {
  if (this.beneficiaryProfileUpdate === 'true' || (sessionStorage.getItem('listBeneficiaryId') && sessionStorage.getItem('relativeId'))) {   //beneficiaryId
    this.profileEducationUpdate = false;
    this.profileUpdate = true;
  } else {
    this.profileEducationUpdate = true;
    this.profileUpdate = false;
  }
}

  setPrimaryDataStepWise(stepName: string, res: any) {
    let primaryData;
    const stepDetails = Array.isArray(res.taskStepDetails) ? res.taskStepDetails.find(x => x.stepName === stepName) : null;
    if (stepDetails) {
      primaryData = {
        ...this.primaryData,
        stepId: stepDetails.id,
        companyId: stepDetails.companyId,
        petitionerId: stepDetails.petitionerId,
        stepName: stepDetails.stepName,
        layoutCode: stepDetails.stepActionList[0]?.layoutCode,
        taskId: stepDetails.taskId,
        isCustomStep: false,
        individualStepId: stepDetails.stepId,
      }
    }
    return primaryData;
  }

  onClickAccordion(item) {
    item == 5 ? this.docStatus = true : this.docStatus = false;
  }

  onClicksimpleAccordion(item) {
    item == 5 ? this.docsimpleStatus = true : this.docsimpleStatus = false;
  }

  // onChange($event) {
  //   this.selectedProfile = $event.value;
  // }
  onEditDetailsChange(newState: boolean) {
    this.editDetails = newState;
  }
  onFormDetailsChange(data: any) {
    this.formDetails = data?.formDetails;
    this.documentType = data?.documentType
  }

  

  cancelReqDataDocs(event:any){
    this.isRequestDataDocuments = false;
    if(event?.save){
      this.getDataLog();
    }
    this.wizardInput = {...this.wizardInput, title: this.individualDetailsTitle};
  }

  getDataLog(){
    this.immigrationWizardService.getDataLog(this.primaryData?.taskTypeId, this.primaryData?.companyId, this.primaryData?.beneficiaryId).pipe(takeUntil(this.destroy$)).subscribe((response: ImagilityBaseResponse) => {
      if(response?.data?.length){
        this.requestDataResponseBen = {...response.data[0], filledDate: response.data[0]?.createDt ? moment(response.data[0]?.createDt).utc().format('DD MMM YYYY HH:mmA') : null};
        this.showErrorBanner = !!(this.requestDataResponseBen?.status?.code === 'PENDING');
        this.showSuccessBanner = !!(this.requestDataResponseBen?.status?.code === 'COMPLETED');
      }else{
        this.showErrorBanner = false;
        this.showSuccessBanner = false;
      }
    });
  }

  confirmResend(){
    this.confirmationService.confirm({
      header: "Resend request for data and documents",          
      rejectLabel: "I will do it later",
      acceptLabel: "Yes, send",
      acceptButtonStyleClass: "btn-accept-resend",
      rejectButtonStyleClass: "btn-cancel-resend",
      message: `<h5>You are about to resend the request for data and documents.
      Do you wish to proceed?</h5>`,
      accept: () => {
        this.immigrationWizardService.resendDataLogs(this.requestDataResponseBen.id)
          .pipe(takeUntil(this.destroy$))
          .subscribe(result => {                
            this.toastService.success(result.message, 'Success');
          });
      },
      reject: () => { },
    });
  }

  requestDataAgain(){
    this.isRequestDataDocuments = true;
    this.wizardInput = {...this.wizardInput, title: this.requestDataTitle};
  }

  ngOnDestroy(): void {
    this.immigrationWizardService.wizardReqDataDocsDetails$.next(false);
    // this.immigrationWizardService.wizardReqDataDocsDetails$.complete();
    this.destroy$.next();
    this.destroy$.complete();
  }


}
